import { render, staticRenderFns } from "./Bistri.vue?vue&type=template&id=162d0c94&scoped=true&"
import script from "./Bistri.vue?vue&type=script&lang=js&"
export * from "./Bistri.vue?vue&type=script&lang=js&"
import style0 from "./Bistri.vue?vue&type=style&index=0&id=162d0c94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162d0c94",
  null
  
)

export default component.exports